import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import Image from 'next/image';
import { LottiePlayer } from './lottie-player';
import styles from './m-animated-illustration.module.scss';
export const MAnimatedIllustration = ({ className, disableMaxWidth = false, height, illustration, loading = 'lazy', lottieAnimationData, width, ...props })=>lottieAnimationData?.filename ? /*#__PURE__*/ _jsx(LottiePlayer, {
        ...props,
        className: classNames(className, disableMaxWidth && styles['max-width']),
        "data-testid": "animated-illustration",
        height: height,
        lottieAnimationData: lottieAnimationData,
        width: width
    }) : Boolean(illustration) && /*#__PURE__*/ _jsx(Image, {
        alt: "",
        className: classNames(className, styles.svg, disableMaxWidth && styles['max-width']),
        height: height ? Number(height) : 1,
        loading: loading,
        priority: loading === 'eager',
        src: `/assets/illustrations/${illustration}.svg`,
        width: width ? Number(width) : 1
    });

//# sourceMappingURL=MAnimatedIllustration.js.map